// AUTO-GENERATED from '2. Literacy Rate.xlsx' (Census 2011).
const LITERACY_RATE = {
  "state": {
    "total_male": 86.77,
    "total_female": 73.44,
    "total_total": 80.09,
    "sc_male": 80.94,
    "sc_female": 65.64,
    "sc_total": 73.26,
    "st_male": 61.81,
    "st_female": 46.8,
    "st_total": 54.34
  },
  "districts": {
    "ARIYALUR": {
      "total_male": 81.23,
      "total_female": 61.74,
      "total_total": 71.34,
      "sc_male": 74.12,
      "sc_female": 55.81,
      "sc_total": 64.93,
      "st_male": 57.46,
      "st_female": 43.53,
      "st_total": 50.37
    },
    "CHENGALPATTU": {
      "total_male": 89.89,
      "total_female": 79.02,
      "total_total": 84.49,
      "sc_male": 84.2,
      "sc_female": 70.44,
      "sc_total": 77.31,
      "st_male": 60.42,
      "st_female": 49.39,
      "st_total": 54.9
    },
    "CHENNAI": {
      "total_male": 93.7,
      "total_female": 86.64,
      "total_total": 90.18,
      "sc_male": 88.79,
      "sc_female": 78.52,
      "sc_total": 83.63,
      "st_male": 88.44,
      "st_female": 80.22,
      "st_total": 84.47
    },
    "COIMBATORE": {
      "total_male": 89.06,
      "total_female": 78.92,
      "total_total": 83.98,
      "sc_male": 75.59,
      "sc_female": 62.35,
      "sc_total": 68.94,
      "st_male": 61.87,
      "st_female": 49.61,
      "st_total": 55.75
    },
    "CUDDALORE": {
      "total_male": 85.93,
      "total_female": 70.14,
      "total_total": 78.04,
      "sc_male": 79.69,
      "sc_female": 63.19,
      "sc_total": 71.44,
      "st_male": 62.66,
      "st_female": 48.58,
      "st_total": 55.65
    },
    "DHARMAPURI": {
      "total_male": 76.85,
      "total_female": 59.8,
      "total_total": 68.54,
      "sc_male": 77.87,
      "sc_female": 59.56,
      "sc_total": 68.85,
      "st_male": 64.75,
      "st_female": 49.21,
      "st_total": 57.09
    },
    "DINDIGUL": {
      "total_male": 84.23,
      "total_female": 68.33,
      "total_total": 76.26,
      "sc_male": 77.27,
      "sc_female": 60.02,
      "sc_total": 68.58,
      "st_male": 57.34,
      "st_female": 46.34,
      "st_total": 51.9
    },
    "ERODE": {
      "total_male": 80.42,
      "total_female": 64.71,
      "total_total": 72.58,
      "sc_male": 66.41,
      "sc_female": 52.1,
      "sc_total": 59.23,
      "st_male": 54.19,
      "st_female": 39.58,
      "st_total": 46.91
    },
    "KALLAKURICHI": {
      "total_male": 80.55,
      "total_female": 63.15,
      "total_total": 71.88,
      "sc_male": 75.46,
      "sc_female": 57.99,
      "sc_total": 66.76,
      "st_male": 51.3,
      "st_female": 37.47,
      "st_total": 44.38
    },
    "KANCHEEPURAM": {
      "total_male": 89.89,
      "total_female": 79.02,
      "total_total": 84.49,
      "sc_male": 84.2,
      "sc_female": 70.44,
      "sc_total": 77.31,
      "st_male": 60.42,
      "st_female": 49.39,
      "st_total": 54.9
    },
    "KANNIYAKUMARI": {
      "total_male": 93.65,
      "total_female": 89.9,
      "total_total": 91.75,
      "sc_male": 92.33,
      "sc_female": 85.57,
      "sc_total": 88.91,
      "st_male": 84.76,
      "st_female": 76.75,
      "st_total": 80.66
    },
    "KARUR": {
      "total_male": 84.54,
      "total_female": 66.86,
      "total_total": 75.6,
      "sc_male": 78.96,
      "sc_female": 60.31,
      "sc_total": 69.44,
      "st_male": 87.74,
      "st_female": 78.46,
      "st_total": 83.23
    },
    "KRISHNAGIRI": {
      "total_male": 78.72,
      "total_female": 63.91,
      "total_total": 71.46,
      "sc_male": 75.85,
      "sc_female": 60.89,
      "sc_total": 68.46,
      "st_male": 53.13,
      "st_female": 42.12,
      "st_total": 47.74
    },
    "MADURAI": {
      "total_male": 89.72,
      "total_female": 77.16,
      "total_total": 83.45,
      "sc_male": 81.73,
      "sc_female": 64.84,
      "sc_total": 73.28,
      "st_male": 80.07,
      "st_female": 63.11,
      "st_total": 71.69
    },
    "MAYILADUTHURAI": {
      "total_male": 89.79,
      "total_female": 77.58,
      "total_total": 83.59,
      "sc_male": 84.23,
      "sc_female": 70.1,
      "sc_total": 77.07,
      "st_male": 66.82,
      "st_female": 59.24,
      "st_total": 62.9
    },
    "NAGAPATTINAM": {
      "total_male": 89.79,
      "total_female": 77.58,
      "total_total": 83.59,
      "sc_male": 84.23,
      "sc_female": 70.1,
      "sc_total": 77.07,
      "st_male": 66.82,
      "st_female": 59.24,
      "st_total": 62.9
    },
    "NAMAKKAL": {
      "total_male": 82.64,
      "total_female": 66.57,
      "total_total": 74.63,
      "sc_male": 74.17,
      "sc_female": 57.76,
      "sc_total": 66.0,
      "st_male": 68.73,
      "st_female": 52.23,
      "st_total": 60.65
    },
    "PERAMBALUR": {
      "total_male": 82.87,
      "total_female": 65.9,
      "total_total": 74.32,
      "sc_male": 80.3,
      "sc_female": 63.23,
      "sc_total": 71.71,
      "st_male": 70.44,
      "st_female": 60.26,
      "st_total": 65.36
    },
    "PUDUKKOTTAI": {
      "total_male": 85.56,
      "total_female": 69.0,
      "total_total": 77.19,
      "sc_male": 82.74,
      "sc_female": 65.38,
      "sc_total": 73.97,
      "st_male": 73.98,
      "st_female": 63.75,
      "st_total": 68.81
    },
    "RAMANATHAPURAM": {
      "total_male": 87.81,
      "total_female": 73.52,
      "total_total": 80.72,
      "sc_male": 81.94,
      "sc_female": 64.96,
      "sc_total": 73.47,
      "st_male": 66.53,
      "st_female": 58.81,
      "st_total": 62.67
    },
    "RANIPET": {
      "total_male": 86.5,
      "total_female": 71.95,
      "total_total": 79.17,
      "sc_male": 85.96,
      "sc_female": 72.54,
      "sc_total": 79.14,
      "st_male": 59.86,
      "st_female": 41.67,
      "st_total": 50.75
    },
    "SALEM": {
      "total_male": 80.24,
      "total_female": 65.15,
      "total_total": 72.86,
      "sc_male": 77.43,
      "sc_female": 60.51,
      "sc_total": 69.08,
      "st_male": 60.39,
      "st_female": 43.17,
      "st_total": 51.85
    },
    "SIVAGANGAI": {
      "total_male": 87.92,
      "total_female": 71.85,
      "total_total": 79.85,
      "sc_male": 83.22,
      "sc_female": 65.37,
      "sc_total": 74.26,
      "st_male": 78.2,
      "st_female": 60.59,
      "st_total": 69.44
    },
    "TENKASI": {
      "total_male": 89.24,
      "total_female": 75.98,
      "total_total": 82.5,
      "sc_male": 83.75,
      "sc_female": 67.23,
      "sc_total": 75.3,
      "st_male": 75.65,
      "st_female": 63.03,
      "st_total": 69.28
    },
    "THANJAVUR": {
      "total_male": 89.04,
      "total_female": 76.5,
      "total_total": 82.64,
      "sc_male": 83.98,
      "sc_female": 68.7,
      "sc_total": 76.26,
      "st_male": 74.15,
      "st_female": 63.02,
      "st_total": 68.38
    },
    "THE NILGIRIS": {
      "total_male": 91.72,
      "total_female": 78.98,
      "total_total": 85.2,
      "sc_male": 89.12,
      "sc_female": 74.11,
      "sc_total": 81.47,
      "st_male": 67.64,
      "st_female": 54.23,
      "st_total": 60.76
    },
    "THENI": {
      "total_male": 85.03,
      "total_female": 69.46,
      "total_total": 77.26,
      "sc_male": 77.75,
      "sc_female": 60.19,
      "sc_total": 69.0,
      "st_male": 49.07,
      "st_female": 42.02,
      "st_total": 45.65
    },
    "THOOTHUKKUDI": {
      "total_male": 91.14,
      "total_female": 81.33,
      "total_total": 86.16,
      "sc_male": 86.56,
      "sc_female": 72.92,
      "sc_total": 79.67,
      "st_male": 71.89,
      "st_female": 58.28,
      "st_total": 65.12
    },
    "TIRUCHIRAPPALLI": {
      "total_male": 89.72,
      "total_female": 76.87,
      "total_total": 83.23,
      "sc_male": 86.51,
      "sc_female": 70.7,
      "sc_total": 78.49,
      "st_male": 81.66,
      "st_female": 68.79,
      "st_total": 75.4
    },
    "TIRUNELVELI": {
      "total_male": 89.24,
      "total_female": 75.98,
      "total_total": 82.5,
      "sc_male": 83.75,
      "sc_female": 67.23,
      "sc_total": 75.3,
      "st_male": 75.65,
      "st_female": 63.03,
      "st_total": 69.28
    },
    "TIRUPATHUR": {
      "total_male": 86.5,
      "total_female": 71.95,
      "total_total": 79.17,
      "sc_male": 85.96,
      "sc_female": 72.54,
      "sc_total": 79.14,
      "st_male": 59.86,
      "st_female": 41.67,
      "st_total": 50.75
    },
    "TIRUPPUR": {
      "total_male": 85.49,
      "total_female": 71.82,
      "total_total": 78.68,
      "sc_male": 68.1,
      "sc_female": 54.93,
      "sc_total": 61.46,
      "st_male": 63.29,
      "st_female": 44.99,
      "st_total": 54.23
    },
    "TIRUVALLUR": {
      "total_male": 89.69,
      "total_female": 78.32,
      "total_total": 84.03,
      "sc_male": 85.38,
      "sc_female": 71.36,
      "sc_total": 78.34,
      "st_male": 59.76,
      "st_female": 48.16,
      "st_total": 53.96
    },
    "TIRUVANNAMALAI": {
      "total_male": 83.11,
      "total_female": 65.32,
      "total_total": 74.21,
      "sc_male": 79.84,
      "sc_female": 63.03,
      "sc_total": 71.41,
      "st_male": 56.02,
      "st_female": 37.53,
      "st_total": 46.81
    },
    "TIRUVARUR": {
      "total_male": 89.13,
      "total_female": 76.72,
      "total_total": 82.86,
      "sc_male": 83.21,
      "sc_female": 67.87,
      "sc_total": 75.5,
      "st_male": 75.6,
      "st_female": 67.37,
      "st_total": 71.35
    },
    "VELLORE": {
      "total_male": 86.5,
      "total_female": 71.95,
      "total_total": 79.17,
      "sc_male": 85.96,
      "sc_female": 72.54,
      "sc_total": 79.14,
      "st_male": 59.86,
      "st_female": 41.67,
      "st_total": 50.75
    },
    "VILLUPURAM": {
      "total_male": 80.55,
      "total_female": 63.15,
      "total_total": 71.88,
      "sc_male": 75.46,
      "sc_female": 57.99,
      "sc_total": 66.76,
      "st_male": 51.3,
      "st_female": 37.47,
      "st_total": 44.38
    },
    "VIRUDHUNAGAR": {
      "total_male": 87.71,
      "total_female": 72.69,
      "total_total": 80.15,
      "sc_male": 80.4,
      "sc_female": 63.11,
      "sc_total": 71.67,
      "st_male": 71.64,
      "st_female": 55.65,
      "st_total": 63.87
    }
  }
};

export default LITERACY_RATE;
